module.exports = __webpack_public_path__ + "1.0.0-d5234419/img/online-database-5.c307a17b.svg";